module.exports = __webpack_public_path__ + "img/preview-6.69d666c2.png";